import { Field, FieldLabel, Input } from '@monksflow/monks-ui';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

export interface TextConfigFieldsProps {
  config: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  disabled: boolean;
}

export function TextConfigFields(props: TextConfigFieldsProps) {
  const { t } = useTranslation('knowledge');
  const maxLength = props.config.maxLength;

  return (
    <Field>
      <FieldLabel htmlFor="brief-section-config-max-length">
        {t('knowledgeHub.briefSectionConfigFields.maxLength')}
      </FieldLabel>
      <Input
        id="brief-section-config-max-length"
        type="number"
        min={1}
        disabled={props.disabled}
        value={typeof maxLength === 'number' ? maxLength : ''}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const raw = event.target.value;
          props.onChange({ maxLength: raw === '' ? null : Number(raw) });
        }}
      />
    </Field>
  );
}
